import React from 'react';
import { Typography, Card, CardMedia, CardContent, CardActionArea } from '@mui/material';
import { LazyBackgroundImage } from 'src/shared/ui/lazy-background-image';

interface Instrument {
  name?: string;
  iconUrl?: string;
}
interface MusicianCardProps {
  className?: string;
  name?: string;
  instruments?: Instrument[];
  imageUrl?: string;
  onClick?: () => void; // Optional click handler
}

const MusicianCard: React.FC<MusicianCardProps> = ({
  className,
  name,
  instruments,
  imageUrl,
  onClick,
}) => {
  console.log(instruments);
  return (
    <Card
      className={`bg-paper h-full ${className || ''}`}
      sx={{
        boxShadow: 'none',
      }}
    >
      <CardActionArea
        onClick={onClick}
        sx={{ display: 'flex', flexDirection: 'column' }}
        className="h-full"
      >
        <div className="p-2 w-full">
          <LazyBackgroundImage
            src={imageUrl || ''}
            placeholder="/assets/images/placeholder/card-placeholder.png"
            className="rounded-lg h-[196px]"
            style={{
              backgroundPosition: 'top center',
            }}
          />
        </div>

        <CardContent className="w-full flex flex-col gap-2 pb-4 h-full">
          <Typography variant="h5">{name}</Typography>
          <div className="w-full flex flex-wrap gap-x-6 gap-y-1">
            {(instruments ?? []).map((instrument, index) => (
              <div key={index} className="flex flex-nowrap items-center gap-x-1">
                <img
                  src={instrument.iconUrl || '/assets/images/play-arrow-filled.png'}
                  className="size-8"
                  alt={instrument.name}
                />
                <Typography variant="body-500">{instrument.name}</Typography>
              </div>
            ))}
          </div>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default MusicianCard;
